import classNames from 'classnames';
import Txt from '../Txt';
import styles from './TxtTitle.module.scss';

/**
 * TxtTitle
 *
 * @return {JSX.Element}
 */
const TxtTitle = ({ className, x, xx, xxx, xxxx, xxxxx, ...rest }) => {
  let Component = 'h5';
  if (xxxx || xxxxx) Component = 'h1';
  if (xxx) Component = 'h2';
  if (xx) Component = 'h3';
  if (x) Component = 'h4';

  const headingProps = { x, xx, xxx, xxxx, xxxxx };

  return (
    <Component
      className={classNames(
        styles.TxtTitle,
        className,
        `${TxtTitle.displayName}`
      )}
    >
      <Txt {...headingProps} {...rest} />
    </Component>
  );
};

TxtTitle.displayName = 'TxtTitle';

export default TxtTitle;
